import React, { Component } from "react";

import styled from "styled-components";

import { TableSortable, mapMetricFromList, DEAL_METRICS } from '@loanbossinc/component-library';
import { assetDataTableClosedDealColumns } from './AssetDataTableClosedDealColumns';
import { assetDataTableSoldDealColumns } from './AssetDataTableSoldDealColumns';
import { filterSoldDeals, filterClosedDeals } from '../../dashboard.filters';
import { DashboardBodyDefaultHeader } from "pages/dashboard/DashboardBodyDefaultHeader";

const StyledWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const SpacerDiv = styled.div`
    margin-top: 2em;
`;

const StyledTableLabel = styled.span`
  && {
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 23px;
    margin-bottom: 1em;
  }
`;

export class AssetDataTable extends Component {
  getSoldDeals = () => {
    const { items, searchText } = this.props;
    let soldDeals = filterSoldDeals(items, searchText);

    soldDeals = soldDeals.map(deal => {
      const exitCap = deal.dealMetrics.filter(metric => metric.metricId === DEAL_METRICS.EXIT_CAP)[0];
      const salesPrice = deal.dealMetrics.filter(metric => metric.metricId === DEAL_METRICS.SALES_PRICE)[0];
      deal.filteredDealMetric = {
        exitCap: exitCap ? exitCap.decimalValue : "--",
        salesPrice:  salesPrice ? salesPrice.decimalValue : "--",        
      }
      return deal;
    });
    return soldDeals;
  }

  getClosedDeals = () => {
    const { items, searchText } = this.props;
    let closedDeals = filterClosedDeals(items, searchText);
    closedDeals = closedDeals.map(deal => {
      const lenderName = deal.dealMetrics.filter(metric => metric.metricId === DEAL_METRICS.LENDER)[0];
      const currentBalance = deal.dealMetrics.filter(metric => metric.metricId === DEAL_METRICS.CURRENT_BALANCE)[0];
      const maturity = deal.dealMetrics.filter(metric => metric.metricId === DEAL_METRICS.MATURITY_DATE)[0];
      deal.filteredDealMetric = {
        lenderName: lenderName ? lenderName.displayValue : "--",
        currentBalance:  currentBalance ? currentBalance.decimalValue : "--",
        maturity:  maturity ? maturity.dateValue : "--",
      }
      return deal;
    });
    return closedDeals;
  }

  render() {
    const {
      title
      , onRowClick
      , onSearchChange
      , onToggleChange
      , toggleOptions
      , searchText
      , menuOptions
      , childDealsFilter
    } = this.props;

    return (
      <StyledWrapper>
        {childDealsFilter}
        <DashboardBodyDefaultHeader
          title={title}
          toggleOptions={toggleOptions}
          onToggleChange={onToggleChange}
          onSearchChange={onSearchChange}
          searchText={searchText}
          menuOptions={menuOptions}
        />

        <SpacerDiv />

        <TableSortable
          columns={assetDataTableClosedDealColumns}
          items={this.getClosedDeals()}
          noDataMessage='No Deals Found'
          onRowClick={(item) => onRowClick(item)}
        />

        <SpacerDiv />

        <StyledTableLabel>Sold Assets</StyledTableLabel>

        <TableSortable
          columns={assetDataTableSoldDealColumns}
          items={this.getSoldDeals()}
          noDataMessage='No Deals Found'
          onRowClick={(item) => onRowClick(item)}
        />
      </StyledWrapper>
    );
  }
}
